/* eslint-disable react/no-array-index-key */
/* eslint-disable space-before-blocks */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-empty */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';
import Carousel from '@brainhubeu/react-carousel';
import ROUTES from '../data/routes';

import { history } from '../routers/AppRouter';

import {
  addWindowResizeCallback,
  removeWindowResizeCallback,
  getWindowDimensions,
  appendScript,
  removeScript,
  getViewport,
  scrollToTopAnimated,
} from '../components/utils';
import { getProductsFeatured, getProductsPromotions, getProductsRecommended } from '../app/store/actions/products';
import ProductItem from '../components/productElements/ProductItem';
import ProductsUtil from '../app/utils/products';
import ProductsData from '../data/products';
import { addLoading, removeLoading } from '../app/store/actions/loading';
import tagManager from '../app/services/tagManager';
import ServerUtils from '../app/utils/server';

import '@brainhubeu/react-carousel/lib/style.css';
import IconsHome from '../components/home/IconsHome';

class HomePage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      maxRecommended: ProductsData.maxRecommendedCarouselTabs,
      manufacturersPerPage: 7,
    };

    this.windowResizeCallback = ({ width }) => {
      this.setManufacturersLength(getViewport(width));
    };
  }

  componentDidMount = () => {
    setTimeout(async () => {
      try {
        addWindowResizeCallback(this.windowResizeCallback);
        this.setManufacturersLength(getViewport(getWindowDimensions().width));
      } catch (e) { }

      try {
        this.props.addLoading();
        await this.props.getProductsFeatured();
        await this.props.getProductsPromotions();
        await this.props.getProductsRecommended();

        if (this.props.location.state
          && this.props.location.state.showContracts
          && this.props.headerRef
          && this.props.headerRef.current) {
          this.props.headerRef.current.showContractsSideMenu();
        }
      } catch (e) {}

      removeScript('/scripts/home.min.js');
      appendScript('/scripts/home.min.js');

      this.onInitSwiperEvents();
      this.removeLoading();
      scrollToTopAnimated();
    }, 0);
  }

  componentWillUnmount = () => {
    this.offSlides();
    removeScript('/scripts/home.min.js');
    removeWindowResizeCallback(this.windowResizeCallback);
  }

  componentWillReceiveProps = async (nextProps) => {
    if (nextProps.contractId !== this.props.contractId) {
      try {
        await this.props.addLoading();
        await this.props.getProductsFeatured();
        await this.props.getProductsPromotions();
        await this.props.getProductsRecommended();
      } catch (e) {}

      removeScript('/scripts/home.min.js');
      appendScript('/scripts/home.min.js');

      this.onInitSwiperEvents();
      this.removeLoading();
    }
  }

  removeLoading = () => setTimeout(this.props.removeLoading, 1000);

  onClickViewProduct = (e, product, index, list) => {
    e.stopPropagation();

    try {
      const productsToSend = [];
      const productsPromotionToSend = [];

      productsToSend.push({
        name: product.name,
        id: product.code,
        price: `${product.price ? (product.price.value || 0) : 0}`,
        brand: product.brand ? product.brand.description : '',
        category: product.category ? product.category.name : '',
        list,
        position: index + 1,
      });

      if (product.price && product.price.promo) {
        productsPromotionToSend.push({
          id: product.code,
          name: product.name,
          creative: list,
          position: index + 1,
        });
      }

      tagManager.ecommerceClick(productsToSend);
      tagManager.ecommercePromotionClick(productsPromotionToSend);
    } catch (err) {}
  }

  onInitSwiperEvents = async () => {
    setTimeout(() => {
      let swiperPromotions = null;
      let swiperRecommended = null;

      // PROMOTIONS
      try {
        swiperPromotions = document.querySelector('.swiper-product-promotion');

        swiperPromotions = swiperPromotions ? swiperPromotions.swiper : null;

        if (swiperPromotions) {
          swiperPromotions.swiperPromotions = swiperPromotions;
          swiperPromotions.slidesPerView = swiperPromotions.params.slidesPerView || 0;
          swiperPromotions.activeIndex = swiperPromotions.activeIndex || 0;
        }
      } catch (e) {}

      // RECOMMENDED
      try {
        swiperRecommended = document.querySelector('.swiper-product-recommended');

        swiperRecommended = swiperRecommended ? swiperRecommended.swiper : null;

        if (swiperRecommended) {
          swiperRecommended.swiperRecommended = swiperRecommended;
          swiperRecommended.slidesPerView = swiperRecommended.params.slidesPerView || 0;
          swiperRecommended.activeIndex = swiperRecommended.activeIndex || 0;
        }
      } catch (e) {}

      this.prepareSendToTagManager(swiperPromotions, swiperRecommended);
      this.onSlidePromotions(swiperPromotions);
      this.onSlideRecommended(swiperRecommended);
    }, 1000);
  }

  onSlidePromotions = (swiperPromotions) => {
    try {
      swiperPromotions.off('slideChange');
      swiperPromotions.on('slideChange', () => {
        try {
          const { productsPromotions = [] } = this.props;
          const productsInPromotion = [];
          const slidesPerView = swiperPromotions.params.slidesPerView;
          const activeIndex = swiperPromotions.activeIndex;
          const maxLength = (activeIndex + slidesPerView) > productsPromotions.length
            ? productsPromotions.length : (activeIndex + slidesPerView);

          for (let index = activeIndex; index < maxLength; index++) {
            const product = productsPromotions[index];
            productsInPromotion.push({
              id: product.code,
              name: product.name,
              creative: I18n.t('productInPromotion'),
              position: index + 1,
            });
          }

          tagManager.ecommerceImpressions(productsInPromotion);
          tagManager.ecommercePromotions(productsInPromotion);
        } catch (e) { }
      });
    } catch (e) {}
  }

  onSlideRecommended = (swiperRecommended) => {
    try {
      swiperRecommended.off('slideChange');
      swiperRecommended.on('slideChange', () => {
        try {
          const { productsRecommended = [] } = this.props;
          const productsInRecommended = [];
          const slidesPerView = swiperRecommended.params.slidesPerView;
          const activeIndex = swiperRecommended.activeIndex;
          const maxLength = (activeIndex + slidesPerView) > productsRecommended.length
            ? productsRecommended.length : (activeIndex + slidesPerView);

          for (let index = activeIndex; index < maxLength; index++) {
            const product = productsRecommended[index];
            productsInRecommended.push({
              name: product.name,
              id: product.code,
              price: `${product.price ? (product.price.value || 0) : 0}`,
              brand: product.brand ? product.brand.description : '',
              category: product.category ? product.category.name : '',
              list: I18n.t('productRecommended'),
              position: index + 1,
            });
          }

          tagManager.ecommerceImpressions(productsInRecommended);
        } catch (e) { }
      });
    } catch (e) {}
  }

  offSlides = () => {
    try {
      const swiperPromotions = document.querySelector('.swiper-product-promotion').swiper;
      swiperPromotions.off('slideChange');
      const swiperRecommended = document.querySelector('.swiper-product-recommended');
      swiperRecommended.off('slideChange');
    } catch (e) {}
  }

  setManufacturersLength = (size = '') => {
    if (size === 'xl') {
      this.setState({ manufacturersPerPage: 7 });
    } else if (size === 'lg') {
      this.setState({ manufacturersPerPage: 5 });
    } else if (size === 'md') {
      this.setState({ manufacturersPerPage: 3 });
    } else if (size === 'sm') {
      this.setState({ manufacturersPerPage: 2 });
    } else {
      this.setState({ manufacturersPerPage: 1 });
    }
  }

  prepareSendToTagManager = async (
    swiperPromotions = {},
    swiperRecommended = {},
  ) => {
    try {
      const products = [];
      const productsInPromotion = [];
      const { productsFeatured = [], productsPromotions = [], productsRecommended = [] } = this.props;

      productsFeatured.forEach((it, index) => {
        products.push({
          name: it.name,
          id: it.code,
          price: `${it.price ? (it.price.value || 0) : 0}`,
          brand: it.brand ? it.brand.description : '',
          category: it.category ? it.category.name : '',
          list: I18n.t('crossSellingProduct'),
          position: index + 1,
        });
      });
      productsPromotions.forEach((it, index) => {
        if (swiperPromotions.swiperPromotions && index < (swiperPromotions.activeIndex + swiperPromotions.slidesPerView)) {
          products.push({
            name: it.name,
            id: it.code,
            price: `${it.price ? (it.price.value || 0) : 0}`,
            brand: it.brand ? it.brand.description : '',
            category: it.category ? it.category.name : '',
            list: I18n.t('productInPromotion'),
            position: index + 1,
          });

          productsInPromotion.push({
            id: it.code,
            name: it.name,
            creative: I18n.t('productInPromotion'),
            position: index + 1,
          });
        }
      });

      productsRecommended.forEach((it, index) => {
        if (swiperRecommended.swiperRecommended && index < (swiperRecommended.activeIndex + swiperRecommended.slidesPerView)) {
          products.push({
            name: it.name,
            id: it.code,
            price: `${it.price ? (it.price.value || 0) : 0}`,
            brand: it.brand ? it.brand.description : '',
            category: it.category ? it.category.name : '',
            list: I18n.t('productRecommended'),
            position: index + 1,
          });
        }
      });

      tagManager.ecommerceImpressions(products);
      tagManager.ecommercePromotions(productsInPromotion);
    } catch (e) {}
  }

  renderBannerBasedUrl = url => (ServerUtils.checkSameHostname(url) ? (
    <Link
      to={url}
      id="bannerImage"
      style={{
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: 'inherit',
        height: 'inherit',
      }}
    />
  ) : (
    <a
      href={url}
      id="bannerImage"
      style={{
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: 'inherit',
        height: 'inherit',
      }}
    />
  ))

  renderBanners = (banners = []) => {
    const orderedBanners = banners.sort((first, second) => {
      if (first.posicion > second.posicion && first.posicion !== null && second.posicion !== null) return 1;
      if (first.posicion < second.posicion && first.posicion !== null && second.posicion !== null) return -1;
      if (second.posicion === null) return -1;
      return 0;
    });
    return (
      orderedBanners.map((banner, index) => (
        <div
          key={`${banner.id}${index}`}
          className="swiper-slide"
          style={{
            backgroundImage: `url('${banner.imageUrl}')`,
          }}
        >
          {this.renderBannerBasedUrl(banner.redirectUrl)}
        </div>
      ))
    );
  }

    renderCategories = (categories = []) => (
      categories.map((category, index) => (
        category.isDisplayCategoryOnHome ? (
          <div key={`categories${category.id}${index}`} className="swiper-slide ">
            <Link
              to={`${ROUTES.PRODUCTS}?categories=${category.id}`}
            >
              <img
                src={category.imageUrl}
                alt={category.name}
                className="image swiper-lazy"
              />
            </Link>
          </div>
        ) : null
      ))
    );

  renderSwiperCrossSelling = (products = []) => (
    products.map((product, index) => (
      <div key={`${product.id}${index}`} className="swiper-slide">
        <Link
          className="swiper-product"
          to={ProductsUtil.getUrl(product)}
          onClick={e => this.onClickViewProduct(e, product, index, I18n.t('crossSellingProduct'))}
        >
          <figure className="image">
            <img src={product.image || '/images/product-image-placeholder.png'} alt={product.name} />
          </figure>
          <span className="name">{product.name}</span>
          <span className="detail">{I18n.t('showDetails').toUpperCase()}</span>
        </Link>
      </div>
    ))
  )

  renderManufacturers = (manufacturers = [], manufacturersPerPage) => (
    !!manufacturers.length && (
      <div key={`manufactures${manufacturersPerPage}`} className="carousel-manufacturers">
        <Carousel
          arrows
          infinite
          slidesPerPage={manufacturersPerPage > manufacturers.length ? manufacturers.length : manufacturersPerPage}
          slidesPerScroll={1}
          autoPlay={3000}
          animationSpeed={400}
        >
          {manufacturers.map((manufacturer, index) => (
            <img key={`${manufacturer.name}${index}`} src={manufacturer.src} alt={manufacturer.name} />
          ))}
        </Carousel>
      </div>
    )
  )

  renderCrossSelling = (products = []) => (
    products.map((product, index) => (
      <ProductItem
        key={`${product.id}${index}`}
        product={product}
        headerRef={this.props.headerRef}
        clickLocation={I18n.t('crossSellingProduct')}
        clickPosition={index}
        location={this.props.location}
      />
    ))
  )

  renderPromotions = (products = []) => (
    <div className="section">
      <div className="container">
        <span className="section__title">{I18n.t('productInPromotion')}</span>
        <div className="product-promotion">
          <div className="swiper-product-promotion swiper-container">
            <div className="swiper-wrapper">
              {products.map((product, index) => (
                <div key={`${product.id}${product.category}${index}`} className="swiper-slide">
                  <ProductItem
                    product={product}
                    headerRef={this.props.headerRef}
                    clickLocation={I18n.t('productInPromotion')}
                    clickPosition={index}
                    location={this.props.location}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="swiper-product-promotion-prev"><svg className="icon icon-arrow-left"><use xlinkHref="#icon-arrow-left" /></svg></div>
          <div className="swiper-product-promotion-next"><svg className="icon icon-arrow-right"><use xlinkHref="#icon-arrow-right" /></svg></div>
        </div>
      </div>
    </div>
  )

  renderRecommended = (products = []) => (
    <div className="section">
      <div className="container">
        <span className="section__title">{I18n.t('productRecommended')}</span>

        <div className="product-recommended">

          <div className="product-recommended__filter">
            <a className="filter active" data-filter="todos">{I18n.t('all').toUpperCase()}</a>
            {products.reduce((ctg, value) => {
              if (ctg.length <= this.state.maxRecommended && (ctg.findIndex(el => el.id === value.category.id) === -1)) ctg.push(value.category);
              return ctg;
            }, []).map((categ, index) => (<a key={`${categ.name}${index}`} className="filter" data-filter={categ.id}>{categ.name.toUpperCase()}</a>))}
          </div>

          <div className="swiper-product-recommended swiper-container">
            <div className="swiper-wrapper">
              {products.map((product, index) => (
                <div key={`${product.id}${product.category.id}${index}`} className="swiper-slide" data-category={product.category.id}>
                  <ProductItem
                    product={product}
                    headerRef={this.props.headerRef}
                    clickLocation={I18n.t('productRecommended')}
                    clickPosition={index}
                    location={this.props.location}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="swiper-product-recommended-prev"><svg className="icon icon-arrow-left"><use xlinkHref="#icon-arrow-left" /></svg></div>
          <div className="swiper-product-recommended-next"><svg className="icon icon-arrow-right"><use xlinkHref="#icon-arrow-right" /></svg></div>
        </div>
      </div>
    </div>
  )

  render() {
    const {
      productsFeatured, productsPromotions, productsRecommended,
      categories, banners, manufacturers,
    } = this.props;

    const { manufacturersPerPage } = this.state;

    return (
      <main>
        <div className="home-destak">
          <div className="container container-home-destak">
            <div
              className="home-destak__banner"
            >
              <div className="swiper-home-banner swiper-container">
                <div className="swiper-wrapper">
                  {this.renderBanners(banners)}
                </div>
                <div
                  className="swiper-banner-pagination"
                  style={{
                    display: 'flex',
                    gap: '1rem',
                    position: 'absolute',
                    zIndex: 10,
                    justifyContent: 'center',
                    opacity: '1',
                    cursor: 'pointer',
                    borderRadius: '100%',
                  }}
                />
              </div>
              <div className="swiper-home-banner-prev" />
              <div className="swiper-home-banner-next" />
            </div>
          </div>
        </div>

        {this.renderManufacturers(manufacturers, manufacturersPerPage)}

        {!!(productsFeatured && productsFeatured.length) && (
          <div className="section">
            <div className="container">
              <span className="section__title">{I18n.t('crossSellingProduct')}</span>
              <div className="products-destak">
                {this.renderCrossSelling(productsFeatured)}
              </div>
            </div>
          </div>
        )}

        <div className="customer-services">
          <div className="container">
            <div className="swiper-customer-services swiper-container">
              <div className="swiper-wrapper">
                <div className="">
                  <div className="text">
                    <svg className="icon icon-entrega"><use xlinkHref="#icon-entrega" /></svg>
                    <p className="description">
                      <strong>{I18n.t('deliveryInEveryBrazilianState')}</strong>
                      {I18n.t('globalServiceStructure')}
                    </p>
                  </div>
                </div>
                <div className="">
                  <div className="text">
                    <svg className="icon icon-garantia"><use xlinkHref="#icon-garantia" /></svg>
                    <p className="description">
                      <strong>{I18n.t('guaranteeQuality')}</strong>
                      {I18n.t('bestProductsOfBestBrands')}
                    </p>
                  </div>
                </div>
                <div className="">
                  <div className="text" style={{ alignContent: 'center' }}>
                    <svg className="icon icon-duvida"><use xlinkHref="#icon-duvida" /></svg>
                    <p className="description">
                      <strong>{I18n.t('needHelp')}</strong>
                      {I18n.t('afterSalesSupport')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="swiper-customer-services-button-prev" />
            <div className="swiper-customer-services-button-next" />
          </div>
        </div>

        {!!(categories && categories.length) && (
          <div className="section section--grey">
            <div className="container">
              <h2 className="title-s1" style={{ marginBottom: '2rem' }}>
                <span>{I18n.t('categories')}</span>
              </h2>

              <div className="category-destak">
                <div className="swiper-category-destak swiper-container">
                  <div className="swiper-wrapper">
                    {this.renderCategories(categories)}
                  </div>
                </div>
                <div className="swiper-categories-button-prev" />
                <div className="swiper-categories-button-next" />
              </div>
            </div>

            <NavLink
              className="btn button_checkbuy allTheProducts"
              to={ROUTES.PRODUCTS}
            >
              {I18n.t('seeTheEntireProductPortfolio')}
            </NavLink>
          </div>
        )}

        {!!(productsPromotions && productsPromotions.length) && this.renderPromotions(productsPromotions)}
        {!!(productsRecommended && productsRecommended.length) && this.renderRecommended(productsRecommended)}
        {<IconsHome />}
      </main>
    );
  }
}

const mapStateToProps = state => ({
  productsFeatured: state.products.featured,
  productsPromotions: state.products.promotions,
  productsRecommended: state.products.recommended,
  contractId: state.contracts.selected && state.contracts.selected.client.id,
  categories: state.settings.categories,
  manufacturers: state.settings.manufacturers,
  banners: state.settings.home && state.settings.home.banners,
});

const mapDispatchToProps = dispatch => ({
  getProductsFeatured: force => dispatch(getProductsFeatured(force)),
  getProductsPromotions: force => dispatch(getProductsPromotions(force)),
  getProductsRecommended: force => dispatch(getProductsRecommended(force)),
  addLoading: () => dispatch(addLoading()),
  removeLoading: () => dispatch(removeLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
